module.exports = __webpack_public_path__ + "img/1.39f9c0e5.png";